import BigNumber from 'bignumber.js';
import { restService } from 'utilities';
import { BRERC_TOKENS } from 'constants/tokens';
import { Market, TokenId } from 'types';

export interface IGetMarketsResponse {
  dailyBrainiac: number;
  markets: Market[];
  request: { addresses: string[] };
  brainiacRate: string;
}

export interface IGetMarketsOutput {
  markets: Market[];
  dailyBrainiacWei: BigNumber | undefined;
}

const getMarkets = async (): Promise<IGetMarketsOutput> => {
  const response = await restService<IGetMarketsResponse>({
    endpoint: '/governance/brainiac',
    method: 'GET',
  });
  if ('result' in response && response.result === 'error') {
    throw new Error(response.message);
  }
  let markets: Market[] = [];
  let dailyBrainiacWei;
  if (response && response.data && response.data.data) {
    dailyBrainiacWei = new BigNumber(response.data.data.dailyBrainiac);
   
    markets = Object.keys(BRERC_TOKENS).reduce<Market[]>((acc: Market[], curr: string) => {
      const activeMarket = response.data?.data.markets.find(
        (market: Market) => market.underlyingSymbol.toLowerCase() === curr.toLowerCase(),
      );
      if (activeMarket) {
        const formattedActiveMarket = {
          ...activeMarket,
          id: activeMarket.underlyingSymbol.toLowerCase() as TokenId,
          tokenPrice: new BigNumber(activeMarket.tokenPrice),
          liquidity: new BigNumber(activeMarket.liquidity),
          borrowBrainiacApy: new BigNumber(activeMarket.borrowBrainiacApy),
          borrowApy: new BigNumber(0).minus(activeMarket.borrowApy),
          supplyBrainiacApy: new BigNumber(activeMarket.supplyBrainiacApy),
          supplyApy: new BigNumber(activeMarket.supplyApy),
          treasuryTotalBorrowsCents: new BigNumber(activeMarket.totalBorrowsUsd).times(100),
          treasuryTotalSupplyCents: new BigNumber(activeMarket.totalSupplyUsd).times(100),
        };
        return [...acc, formattedActiveMarket];
      }
      return acc;
    }, []);
  }
  return { markets, dailyBrainiacWei };
};

export default getMarkets;
